export enum FavoritesListType {
    Personal = "Personal",
    Account = "Account"
};

export enum FavoritesListPermissions {
    Inclusion = 10,
    Exclusion = 20,
    ReInclusion = 30
};

export enum DisplayAsList {
    Item = 0,
    Category = 1
};

export enum FavoritesSortCode {
    "Brand A-Z" = "BA",
    "Brand Z-A" = "BD",
    "Most Popular" = "BM",
    "Preferred Items" = "C1",
    "Catalog Items" = "C2",
    "Green" = "GI",
    "Item A-Z" = "IA",
    "Item Z-A" = "ID",
    "Diversity Owned" = "MO",
    "Price Low-High" = "PA",
    "Price High-Low" = "PD",
    "Recycled" = "RI"
};
